import IndustrialWaste from '../components/IndustrialWaste';

function IndustrialWastePage() {
  return <IndustrialWaste />;
}

export default IndustrialWastePage;
